export default "__VITE_ASSET__DIWiebd0__"